<template>
  <generic-modal :title="$t('dictamen')" ref="generic_modal">
    <form>
      <div class="field">
        <label class="label">{{ $t("name") }}</label>
        <div class="control">
          <input class="input" type="text" v-model="meta.name" />
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("dpi") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.dpi" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("nit") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="meta.nit" />
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("promissory note number") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="meta.promissory_note_number"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field" v-if="meta.settings">
            <label class="label">{{ $t("report date") }}</label>
            <div class="control">
              <input
                class="input"
                type="date"
                v-model="meta.settings.report_date"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="field" v-if="meta.settings">
        <label class="label">{{ $t("main economical activity") }}</label>
        <div class="control">
          <input
            class="input"
            type="text"
            v-model="meta.settings.main_economical_activity"
          />
        </div>
      </div>

      <div class="columns">
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('analyst signer')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/signer/catalog"
              name_field="name"
              value_field="signer_id"
              @selected="analyst_signer_changed"
              ref="analyst_signer_dropdown"
            />
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "DictamenModal",
  components: { GenericModal, GenericDropdown },
  data() {
    return {
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();

      get("/dictamen", { uuid: uuid })
        .then((element) => {
          v.meta = element;
          v.$refs.generic_modal.show_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/dictamen", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/dictamen", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
      v.$refs.analyst_signer_dropdown.clear();
      // v.uuid = "";
    },
    analyst_signer_changed(signer) {
      // console.log("analyst_signer_changed", signer);
      let v = this;
      if (signer) {
        v.meta.settings.analyst_signer_id = signer.signer_id;
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
